import React from "react";
import { Redirect } from "react-router-dom";
import { httpRequest } from "../../utils/networkCalls";
export default function ReactPayPal({
    formSchema,
    isCpnApplied,
    price,
    couponDis,
    coupon,
    setPbStep,
}) {
    const [paid, setPaid] = React.useState(false);
    const [error, setError] = React.useState(null);
    const paypalRef = React.useRef();
    // const [orderDetails, setOrderDetails] = React.useState();

    // To show PayPal buttons once the component loads
    React.useEffect(() => {
        // console.log(formSchema);
        window.paypal
            .Buttons({
                style: {
                    shape: "rect",
                    color: "blue",
                    layout: "vertical",
                    label: "pay",
                },

                createOrder: (data, actions) => {
                    return actions.order.create({
                        intent: "CAPTURE",
                        purchase_units: [
                            {
                                custom_id: formSchema.orderID,
                                amount: {
                                    value: price.totalAmount,
                                },
                            },
                        ],
                    });
                },
                onApprove: async (data, actions) => {
                    const order = await actions.order.capture();
                    // setOrderDetails(order);
                    await httpRequest(
                        "/payment/paypal-transaction-verify",
                        "post",
                        {
                            orderID: formSchema.orderID,
                            payID: order.id,
                        }
                    );
                    // console.log(PayPalTransVerify, "verify");
                    if (isCpnApplied) {
                        await httpRequest("/coupon/applied", "post", {
                            code: coupon,
                            orderID: formSchema.orderID,
                            o_amt: Number(couponDis) + Number(price.totalAmount),
                            d_amt: price.totalAmount,
                        });
                    }
                    setPaid(true);
                    setPbStep("successful");
                },
                onError: (err) => {
                    setError(err);
                    console.error(err);
                },
            })
            .render(paypalRef.current);
    }, []);

    // If the payment has been made
    // if (paid) {
    //     return <Redirect pathname: `/payment-successful/oid=${formSchema.orderID}&stl=me..69i57jA69FF59IjI0jJGD69iHF60l5.1721j0j7` />;
    // }

    // If any error occurs
    if (error) {
        return <div>Error Occurred in processing payment.! Please try again.</div>;
    }

    // Default Render
    return (
        <>
            {paid && (
                <Redirect
                    to={`/payment-successful?order-id=${formSchema.orderID}&stype=${formSchema.stype}&stl=me..69i57jA69FF59IjI0jJGD69iHF60l5.1721j0j7`}
                />
            )}
            <div ref={paypalRef} />
            <img
                src="https://cdn.styldod.com/react_user_dashboard/assets/paypal-checkout-ud.png"
                loading="lazy"
                alt=""
                className="ud-secure-image"
            />
        </>
    );
}
